import React from "react";
import "./Footer.css";
import logo from "../assets/logo.png"; 

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="footer-inner">
          {/* Column 1: Logo + Contact */}
          <div className="footer-col footer-contact">
            <img src={logo} alt="Company Logo" className="footer-logo" />
            <h4 className="company-name">Qnexa Services Pvt. Ltd.</h4>

            <address className="footer-address">
              16-58/8, YSR Colony,<br />VTC:Narasapuram,
              PO:Narsapur,<br /> District: West Godavari,<br />State:Andhra Pradesh,<br />PIN Code: 534275,<br />
               India.
            </address>

            <div className="footer-phones">
              <div className="phone">📞 <a href="tel:+8978418889">+91 8978418889</a></div>
              <div className="phone">📞 <a href="tel:+8978418889">+91 8712891889</a></div>
            </div>

            
            <div className="footer-email">✉️ <a href="mailto:jeeju@qnexaservices.com">jeeju@qnexaservices.com</a></div>
            <div className="footer-email">✉️ <a href="mailto:satishk@qnexaservices.com">satishk@qnexaservices.com</a></div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="footer-col footer-links">
            <h4>QUICK LINKS</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/resources">Resources</a></li>
              <li><a href="/complaint">Complaint</a></li>
              <li><a href="/careers">Careers</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          {/* Column 3: Our Presence */}
          <div className="footer-col footer-presence">
            <h4>OUR PRESENCE</h4>
            <p>
              Explore the comprehensive technical expertise provided by Qnexa Services' regional
              connections across India. Uncover our extensive coverage and local support.
            </p>
          </div>

          {/* Column 4: Social Media */}
          <div className="footer-col footer-social">
            <h4>SOCIAL MEDIA</h4>
            <p>Connect with us on our social profiles</p>

            <div className="social-icons">
              <a href="https://facebook.com" aria-label="Facebook" target="_blank" rel="noreferrer">
                {/* facebook svg */}
                <svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" rx="6" fill="#06094A"/>
                  <path d="M15.2 8.5H13.8C12.8 8.5 12.6 9 12.6 9.7V11.1H15.2L14.8 13.2H12.6V19H10.1V13.2H8.1V11.1H10.1V9.1C10.1 6.7 11.4 5.4 13.7 5.4C14.6 5.4 15.6 5.5 15.9 5.6V8.5H15.2Z" fill="#fff"/>
                </svg>
              </a>

              <a href="https://instagram.com" aria-label="Instagram" target="_blank" rel="noreferrer">
                {/* instagram svg */}
                <svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" rx="6" fill="#06094A"/>
                  <path d="M7.5 7.5H16.5V16.5H7.5V7.5Z" stroke="#fff" strokeWidth="1.2"/>
                  <path d="M12 9.2A2.8 2.8 0 1 0 12 14.8A2.8 2.8 0 1 0 12 9.2Z" stroke="#fff" strokeWidth="1.2"/>
                  <path d="M16.6 7.4H16.64" stroke="#fff" strokeWidth="1.4" strokeLinecap="round"/>
                </svg>
              </a>

              <a href="https://linkedin.com" aria-label="LinkedIn" target="_blank" rel="noreferrer">
                {/* linkedin svg */}
                <svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" rx="6" fill="#06094A"/>
                  <path d="M7.5 10.5H10V19H7.5V10.5Z" fill="#fff"/>
                  <path d="M8.75 7.5A1.25 1.25 0 1 0 8.75 4.9999 1.25 1.25 0 0 0 8.75 7.5Z" fill="#fff"/>
                  <path d="M12.5 13.5V19H15V13.2C15 11.6 13.6 11 12.7 11C11.7 11 11.2 11.7 11 12.1V11H8.5V19H11V13.5H12.5Z" fill="#fff"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* bottom bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          

          <div className="footer-bottom-right">
            © {new Date().getFullYear()} Qnexa Services Private Limited. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
